import type { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';

import FormField from '@/components/atoms/FormField';
import TextField from '@/components/atoms/TextField';
import { SuggestNameButton } from '@/components/organisms/FishGroupForms';
import type { OverviewCage } from '@/domain/fishGroups';
import type {
    OperateWizardAction,
    WizardDestination,
} from '@/routes/Internal/routes/Client/FishGroupsOverview/actions/operations/operateWizardReducer';

interface Props {
    mergeTargetDestination: WizardDestination;
    locationCages: OverviewCage[];
    dispatch: Dispatch<OperateWizardAction>;
}

/**
 * Always rendered once the stub at destinations[1] exists, which guarantees a stable tempId
 * before any cage is picked, so the operator can name the merged FG independently of their
 * cage choice.
 */
export function TargetNameField(props: Props) {
    const { mergeTargetDestination, locationCages, dispatch } = props;
    const { t } = useTranslation('fishGroups');

    return (
        <FormField
            size="sm"
            htmlFor={`${mergeTargetDestination.tempId}-name`}
            label={t('actions.operate.splitAndMerge.target.newFGNameLabel')}
            labelAction={
                <SuggestNameButton
                    cageName={
                        locationCages.find((c) => c.cageId === mergeTargetDestination.cageId)
                            ?.cageName
                    }
                    operation="split_and_merge"
                    onApply={(value) =>
                        dispatch({
                            type: 'setDestinationName',
                            tempId: mergeTargetDestination.tempId,
                            value,
                        })
                    }
                />
            }>
            <TextField
                id={`${mergeTargetDestination.tempId}-name`}
                type="text"
                placeholder={t('actions.operate.destinations.fields.namePlaceholder')}
                value={mergeTargetDestination.name}
                onChange={(e) =>
                    dispatch({
                        type: 'setDestinationName',
                        tempId: mergeTargetDestination.tempId,
                        value: e.target.value,
                    })
                }
            />
        </FormField>
    );
}
